import React from 'react';
import BottomSection from '../components/BottomSection';
import homeHero from '../assets/images/home-hero.png';
import homeHeroFeature1 from '../assets/images/home-hero-feature-1.png';
import homeHeroFeature2 from '../assets/images/home-hero-feature-2.png';
import homeHeroFeature3 from '../assets/images/home-hero-feature-3.png';
import homeHeroFeature4 from '../assets/images/home-hero-feature-4.png';
import category1 from '../assets/images/home-categories/home-category-1.png';
import category2 from '../assets/images/home-categories/home-category-2.png';
import category3 from '../assets/images/home-categories/home-category-3.png';
import category4 from '../assets/images/home-categories/home-category-4.png';
import category5 from '../assets/images/home-categories/home-category-5.png';
import category6 from '../assets/images/home-categories/home-category-6.png';
import category7 from '../assets/images/home-categories/home-category-7.png';
import category8 from '../assets/images/home-categories/home-category-8.png';
import homeGuarantee from '../assets/images/home-guarantee.png';
import homePerformance from '../assets/images/home-performance.png';
import homeEndorsement from '../assets/images/home-endorsement.png';

const homeHeroFeatures = [
  { src: homeHeroFeature1, alt: '30分钟达' },
  { src: homeHeroFeature2, alt: '正品保障' },
  { src: homeHeroFeature3, alt: '全平台覆盖' },
  { src: homeHeroFeature4, alt: '美妆个护全品类' },
];

const homeCategories = [
  { src: category1, label: '彩妆香水' },
  { src: category2, label: '大牌护肤' },
  { src: category3, label: '个人护理' },
  { src: category4, label: '女性护理' },
  { src: category5, label: '差旅一次性' },
  { src: category6, label: '美妆工具' },
  { src: category7, label: '面膜修护' },
  { src: category8, label: '家清纸品' },
];

type SectionHeadingProps = {
  title: string;
  subtitle: string;
};

function SectionHeading({ title, subtitle }: SectionHeadingProps) {
  return (
    <header className="home-section-heading">
      <h2>{title}</h2>
      <p>{subtitle}</p>
    </header>
  );
}

function HomePage() {
  return (
    <main className="home-page">
      <section className="home-section home-hero-section">
        <img className="home-hero-image" src={homeHero} alt="价探首页首屏展示" />

        <div className="home-hero-feature-row" style={{ width: '85%' }}>
          {homeHeroFeatures.map((feature) => (
            <img
              className="home-hero-feature-image"
              key={feature.alt}
              src={feature.src}
              alt={feature.alt}
            />
          ))}
        </div>
      </section>

      <section className="home-section home-categories-section" style={{ marginTop: '5%' }}>
        <SectionHeading title="8大经营核心品类" subtitle="8 Major Core Business Categories" />

        <div className="home-categories-grid">
          {homeCategories.map((category) => (
            <article className="home-category-card" key={category.label}>
              <img className="home-category-image" src={category.src} alt={category.label} />
              <h3>{category.label}</h3>
            </article>
          ))}
        </div>
      </section>

      <section className="home-section home-showcase-section" style={{ marginTop: '-2%' }}>
        <SectionHeading title="正品保正体系" subtitle="Genuine Product Guarantee System" />

        <div className="home-showcase-frame home-showcase-frame-soft">
          <img className="home-figure-image" src={homeGuarantee} alt="价探正品保障体系展示" />
        </div>
      </section>

      <section className="home-section home-showcase-section" style={{ marginTop: '-5%' }}>
        <SectionHeading title="发展表现" subtitle="Development Performance" />

        <div className="home-showcase-frame">
          <img className="home-figure-image" src={homePerformance} alt="价探发展表现展示" />
        </div>
      </section>

      <section className="home-section home-showcase-section" style={{ marginTop: '-5%' }}>
        <SectionHeading title="行业背书" subtitle="Industry Endorsement" />

        <div className="home-showcase-frame home-showcase-frame-dark">
          <img className="home-figure-image" src={homeEndorsement} alt="价探行业背书展示" />
        </div>
      </section>

      <BottomSection />
    </main>
  )
}

export default HomePage;
